import { deferErrorRaisedAfterPage } from '@/utils/fetchErrorPage'

export default () => {
  deferErrorRaisedAfterPage(window.__NUXT__, window.onNuxtReady)
}
